module.exports = __webpack_public_path__ + "assets/img/goConsumption.15733b5b.png";